import { convertVariantAttributeRangeToSelectableValues, VariantAttribute } from '@vp/upload-and-print-validator';
import { ProductOptions } from 'src/providers/ProductContextProvider';
import { getProductOptions } from 'src/services/msxService';

function getTranslationsForProductOption(translations: VariantAttribute[] | null, productOptionKey: string) {
  return translations?.find(productOption => productOption.key.key === productOptionKey);
}

export function getTranslatedNameForProductOptionValue(
  translations: VariantAttribute[] | null,
  productOptionKey: string,
  productOptionValue: string
): string | undefined {
  const translationsForOption = getTranslationsForProductOption(translations, productOptionKey);
  return translationsForOption?.values.find(value => value.key === productOptionValue)?.merchandisingName;
}

export function getTranslatedNameForProductOptionKey(
  translations: VariantAttribute[] | null,
  productOptionKey: string
): string | undefined {
  return getTranslationsForProductOption(translations, productOptionKey)?.key.merchandisingName;
}

export async function filterRecommendedProductOptionsToJustProductPageOptions(
  productKey: string,
  productVersion: number,
  recommendedProductOptions: ProductOptions
): Promise<{ [optionName: string]: string }> {
  const nonPdcProductOptionsWithRange = await getProductOptions(productKey, productVersion);
  const nonPdcProductOptions = convertVariantAttributeRangeToSelectableValues(nonPdcProductOptionsWithRange);
  const productOptionsToAccept = Object.entries(recommendedProductOptions).filter(([key]) => {
    return nonPdcProductOptions.find(nonPdcOption => nonPdcOption.key.key === key) !== undefined;
  });
  return Object.fromEntries(productOptionsToAccept);
}

export function updateProductOptionQueryParameters(updatedOptions: { [name: string]: string }): void {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set('selectedOptions', JSON.stringify(updatedOptions));
  window.history.replaceState(null, '', `?${queryParams}`);
}

export function pickRecommendedOptions(recommendationOptions: ProductOptions, selectedKeys: string[]): ProductOptions {
  const newSelectedOptions = selectedKeys.reduce<ProductOptions>((acc, key) => {
    const value = recommendationOptions[key];
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
  return newSelectedOptions;
}
